import { getProductHref } from 'utils/helpers/productHref';

/**
 * Eva product href. Delegates to shared product href rules (Caris MDP vs
 * `/products/{slug}`).
 */
export const getEvaProductHref = (slug: string): string => getProductHref(slug);
